import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import MultimediaHome from "../Components/Multimedia/MultimediaHome/MultimediaHome";

function MultimediaGallery() {
  return (
    <>
      <Navbar />
      <MultimediaHome />
      <Footer />
    </>
  );
}

export default MultimediaGallery;
